"use strict";
// @ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoReconnectAllDevices = void 0;
var __1 = require("..");
var deviceUUIDMap = {
    Alto2: '6cd6c8b5-e378-0107-000a-1b9740683449',
    ePod2: '6cd6c8b5-e378-0104-000a-1b9740683449',
    ePod3: '6cd6c8b5-e378-0106-000a-1b9740683449',
    SmartBox: '6cd6c8b5-e378-0109-000a-1b9740683449',
    ePod: '6cd6c8b5-e378-0103-000a-1b9740683449',
};
var findDeviceTypeFromUUID = function (uuid) {
    switch (uuid) {
        case deviceUUIDMap.Alto2:
            return 'Alto2';
        case deviceUUIDMap.ePod2:
            return 'ePod2';
        case deviceUUIDMap.ePod3:
            return 'ePod3';
        case deviceUUIDMap.SmartBox:
            return 'SmartBox';
        default:
            return 'ePod';
    }
};
var autoReconnectAllDevices = function (devicesToReconnect, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var devices, _i, devices_1, el;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(navigator.userAgent.indexOf('BLE Browser') >= 0 ||
                    navigator.userAgent.indexOf('Nuviu') >= 0)) return [3 /*break*/, 9];
                console.log('startAutoreconnection');
                return [4 /*yield*/, navigator.bluetooth.getDevices({
                        filters: [
                            {
                                services: [
                                    deviceUUIDMap.Alto2,
                                    deviceUUIDMap.ePod2,
                                    deviceUUIDMap.ePod,
                                    deviceUUIDMap.ePod3,
                                    deviceUUIDMap.SmartBox,
                                ],
                            },
                        ],
                    })];
            case 1:
                devices = _a.sent();
                if (!(devices.length > 0)) return [3 /*break*/, 7];
                _i = 0, devices_1 = devices;
                _a.label = 2;
            case 2:
                if (!(_i < devices_1.length)) return [3 /*break*/, 6];
                el = devices_1[_i];
                if (!devicesToReconnect.includes(el.name)) return [3 /*break*/, 4];
                return [4 /*yield*/, handleAutoreconnection(el, callback)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                console.log(el.name + " can't be connected");
                _a.label = 5;
            case 5:
                _i++;
                return [3 /*break*/, 2];
            case 6: return [3 /*break*/, 8];
            case 7:
                console.log('No devices');
                _a.label = 8;
            case 8: return [3 /*break*/, 10];
            case 9:
                console.log('Autoreconnection not available in this browser');
                _a.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}); };
exports.autoReconnectAllDevices = autoReconnectAllDevices;
var handleAutoreconnection = function (bleDevice, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var deviceUUID, deviceType, server, device;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviceUUID = bleDevice.adData.serviceData[0];
                deviceType = findDeviceTypeFromUUID(deviceUUID);
                return [4 /*yield*/, bleDevice.gatt.connect()];
            case 1:
                server = _a.sent();
                device = __1.vuse.setDevice(deviceType);
                if (typeof callback === 'function') {
                    callback(device);
                }
                return [4 /*yield*/, device.autoReconnect(bleDevice, server)];
            case 2:
                _a.sent();
                return [2 /*return*/, device];
        }
    });
}); };
